module.exports = __webpack_public_path__ + "img/Checkmark_Green.11261c54.svg";